export default {
	"streams": {
		"qmusic": {
			"name": "Qmusic",
			"stationId": "qmusic_nl",
			"aac": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_live_32.aac",
			"vorbis": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_live_64.ogg",
			"mp3": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_live_96.mp3",
			"flash": {
				"stream": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_live_96.mp3?type=.flv"
			},
			"video": "theoplayer://dpp-qmusicnl-live.akamaized.net/streamx/QmusicNL.m3u8",
			"videoOptions": {
				"pcode": "p4dmQyOsCE4guGeAXQ6wbJ0tbWH9",
				"playerBrandingId": "45a986f844274566ac8fc6c41a50faea",
				"linearAdSkipButtonStartTime": 0,
				"adSetCode": "a9127b419b14b5e8455579bc3555cc7",
				"wmode": "opaque",
				"google-ima-ads-manager": {
					"showInAdControlBar": true,
					"showAdMarquee": false,
					"playWhenAdClick": false,
					"adRequestTimeout": 3000
				}
			}
		},
		"nonstop": {
			"name": "Qmusic nonstop",
			"stationId": "nonstop_qnl",
			"aac": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_nonstop_32.aac",
			"vorbis": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_nonstop_64.ogg",
			"mp3": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_nonstop_96.mp3",
			"flash": {
				"stream": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_nonstop_96.mp3?type=.flv"
			}
		},
		"fouteuur": {
			"name": "Qmusic foute uur",
			"stationId": "foute_uur_nl",
			"aac": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_fouteuur_32.aac",
			"vorbis": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_fouteuur_64.ogg",
			"mp3": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_fouteuur_96.mp3",
			"flash": {
				"stream": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_fouteuur_96.mp3?type=.flv"
			}
		},
		"hotnow": {
			"name": "Qmusic hot now",
			"stationId": "hotnow_qnl",
			"aac": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_new_32.aac",
			"vorbis": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_new_64.ogg",
			"mp3": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_new_96.mp3",
			"flash": {
				"stream": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_new_96.mp3?type=.flv"
			}
		},
		"classics": {
			"name": "Qmusic Summer",
			"stationId": "classics_qnl",
			"aac": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_classics_32.aac",
			"vorbis": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_classics_64.ogg",
			"mp3": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_classics_96.mp3",
			"flash": {
				"stream": "https://icecast-qmusicnl-cdp.triple-it.nl/Qmusic_nl_classics_96.mp3?type=.flv"
			}
		}
	},
	"defaultStream": "qmusic",
	"screenSets": {
		"loginScreenSet": "Qmusic-site-login",
		"loginScreenSetMobile": "Qmusic-site-login",
		"profileScreenSet": "Qmusic-site-profile",
		"profileScreenSetMobile": "Qmusic-site-profile",
		"regSource": "qmusic_web"
	},
	"mediaAPIs": {
		"youtube": "https://www.youtube.com/iframe_api",
		"soundcloud": "https://w.soundcloud.com/player/api.js",
		"playbuzz": "https://cdn.playbuzz.com/widget/feed.js",
		"facebook": "https://connect.facebook.net/en_US/sdk.js",
		"mc_api": "https://dpg-api.mychannels.com/v1/",
		"ooyala": [
			"https://player.ooyala.com/static/v4/stable/latest/core.min.js",
			"https://player.ooyala.com/static/v4/stable/latest/video-plugin/main_html5.min.js",
			"https://player.ooyala.com/static/v4/stable/latest/video-plugin/bit_wrapper.min.js",
			"https://player.ooyala.com/static/v4/stable/latest/skin-plugin/html5-skin.min.js",
			"https://player.ooyala.com/static/v4/stable/latest/ad-plugin/google_ima.min.js",
			"https://player.ooyala.com/static/v4/stable/latest/other-plugin/discovery_api.min.js",
			"https://player.ooyala.com/static/v4/stable/latest/ad-plugin/ad_manager_vast.min.js",
			"https://player.ooyala.com/static/v4/stable/latest/skin-plugin/html5-skin.min.css"
		],
		"theoplayer": [
			"https://analytics.ooyala.com/static/analytics.js",
			"https://video.persgroep.net/theoplayer/THEOplayer.js",
			"https://video.persgroep.net/theoplayer/theo-chartbeat.js",
			"https://video.persgroep.net/theoplayer/theo-main_v1.3.js",
			"https://video.persgroep.net/theoplayer/ui.css",
			"https://video.persgroep.net/theoplayer/theoplayer_main_skin.css"
		]
	},
	"csrfOrigin": "https://qmusic.nl/_csrf/",
	"stationId": "qmusic_nl",
	"apiUrl": "https://api-test.qmusic.nl",
	"socketUrl": "https://socket.qmusic.nl/api",
	"cdnUrl": "https://static1.qmusic.medialaancdn.be",
	"apiVersion": "2.0",
	"gigyaApiKey": "3_eUewIo0_d4RN5jogqQsLBa6nykj43odcx2kyAEqpJWr7h3EEZNx3DKgbfwBnjV0h",
	"cookieCheckRequired": true,
	"acceptedCookieValue": "true",
	"dfp_network": 7191
}
